module.exports = __webpack_public_path__ + "static/media/website.4cb5892f.png";